import styles from '../product-comparison-grid.module.scss';
import cx from 'classnames';
import { Conditional } from '@cat-ecom/pcc-components';
import { shouldShowDiscountedPrice } from './utils';

interface ProductCardPriceProps {
  currency: string;
  totalPrice: string;
  discountAmount: string;
  unitPrice: string;
}

const ProductCardPrice = ({
  currency,
  totalPrice,
  discountAmount,
  unitPrice
}: ProductCardPriceProps) => {
  const showDiscountedAmount = shouldShowDiscountedPrice(
    discountAmount,
    unitPrice
  );
  const conditionalPrice = showDiscountedAmount ? unitPrice : totalPrice;
  const priceClasses = showDiscountedAmount
    ? styles['unit-price-discounted']
    : 'cat-u-theme-typography-label-lg';

  return (
    <div>
      <Conditional test={showDiscountedAmount}>
        <p
          className={cx('mb-0', styles['product-comparison__card-price'])}
          data-testid="discounted-price-id"
        >
          <span className="cat-u-theme-typography-label-lg">{totalPrice}</span>
          <span className="cat-u-theme-typography-footnote"> {currency}</span>
        </p>
      </Conditional>
      <p
        className={cx(
          {
            'lh-1': showDiscountedAmount
          },
          'mb-0',
          styles['product-comparison__card-price']
        )}
      >
        <span className={priceClasses}>{conditionalPrice}</span>
        <span
          className={cx('cat-u-theme-typography-footnote', {
            'text-decoration-line-through': showDiscountedAmount,
            [styles['unit-price-discounted']]: showDiscountedAmount
          })}
        >
          &nbsp;
          {currency}
        </span>
      </p>
    </div>
  );
};

export default ProductCardPrice;
